import { getProxiedServiceUrl } from '@xengage/gw-portals-url-js';
import { JsonRPCService } from '@xengage/gw-portals-transport-js';
import { getConfigValue } from '@jutro/config';
import { loadGtag, DefaultDictionaryProvider,
    DefaultWhitelistProvider } from '@jutro/events';
import appConfig from 'app-config';


export default class Analytics {

   // ga = loadGA(getConfigValue('GA_TRACKING_ID'));

    static trackActivity(data,additionalHeaders) {
        return JsonRPCService.send(getProxiedServiceUrl('analytics'), 'trackActivity',data, additionalHeaders);
    }

    static trackGAPageView(title,page){
        // return ((loadGA(getConfigValue('GA_TRACKING_ID')))('send', 'pageview',title));
        const  ga = loadGtag(getConfigValue('GA_TRACKING_ID'));
        ga('set', {
            page: title,
            title: page
        });
        return ga('send', 'pageview',title,page);
        
        
    }


    static trackGAEvent(title,page)
    {
        
        const  ga = loadGtag(getConfigValue('GA_TRACKING_ID'));
        return ga('send', {
            hitType: 'event',

            eventCategory: title,
            // eventAction: topic,
            eventLabel: page,
        });  
    }


    
}

